import React from 'react';

import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';

import { FilterCheckbox } from '@components';
import { ILoginState, ICarsState } from '@share/store/slices';
import { RootState } from '@share/utils';
import { IBudgetRange, ICounterItem } from '@share/common-types';
import { getFilterList, getFilterListB } from '@utils';

import { RouteComponentProps, withRouter } from 'react-router-dom';

import './style.scss';

interface IMapStateToProps {
  carsStore: ICarsState;
  loginStore: ILoginState;
}

interface IProps extends IMapStateToProps, WrappedComponentProps, RouteComponentProps {
  counters: (ICounterItem | IBudgetRange)[];
  filters: string[];

  title: string;

  disabled?: boolean;
  exluceNonSelected?: boolean;
  displayAll?: boolean;
  displayZero?: boolean;
  hideBorder?: boolean;

  orderByOptions?: boolean;

  getKeyConverter?: (key: any) => string;
  getLabelConverter?: (key: any) => any;

  onFiltersChange: (checkedValues: string[]) => void;
}

interface IState {
  isFullToShow: boolean;
}

const maxAmenitiesCount = 6;

const toFilterKey = (rawKey: any, converter?: (key: any) => string): string => {
  if (rawKey == null) {
    return '';
  }

  if (converter) {
    const converted = converter(rawKey);
    if (converted != null && converted !== '') {
      return String(converted);
    }
  }

  if (typeof rawKey === 'object') {
    const nestedKey = rawKey.key ?? rawKey.value;
    return nestedKey != null ? String(nestedKey) : '';
  }

  return String(rawKey);
};

const toFilterLabel = (rawKey: any, converter?: (key: any) => any): any => {
  if (rawKey == null) {
    return '';
  }

  if (converter) {
    const converted = converter(rawKey);
    if (converted != null && converted !== '') {
      return converted;
    }
  }

  if (typeof rawKey === 'object') {
    return rawKey.value ?? rawKey.key ?? '';
  }

  return rawKey;
};

class CarsFilterItemComponent extends React.Component<IProps, IState> {
  state: IState = {
    isFullToShow: false,
  };

  render(): React.ReactNode {
    const { isFullToShow } = this.state;
    const { hideBorder, carsStore, counters, filters, title, exluceNonSelected, disabled, displayZero, displayAll, orderByOptions, getKeyConverter, getLabelConverter } = this.props;
    const { isSessionExpired } = carsStore;

    let countersToShow: (ICounterItem | IBudgetRange)[] | undefined;

    let isShow;

    if (!!counters) {
      countersToShow = getFilterListB(counters, filters, !!isFullToShow || !!displayAll, exluceNonSelected);

      if (orderByOptions) {
        countersToShow = countersToShow.slice();
        countersToShow.sort((a, b) => b.count - a.count);
      }
      
      isShow = !!counters.filter(({ count }) => !!count).length;
    }
    
    if (!isShow || (counters?.length === 1 && counters?.map(({ key}) => toFilterKey(key, getKeyConverter)).includes('Unspecified'))) {
      return null;
    }
    
    return (
      <>
        <FilterCheckbox
          disabled={isSessionExpired || disabled}
          onChange={this.props.onFiltersChange}
          values={filters}
          displayZero={displayZero}
          excludeBorder={hideBorder}
          options={countersToShow?.reduce<{ count: number; value: string; label: any; disabled?: boolean }[]>((options, { count, key, disabled }) => {
            const value = toFilterKey(key, getKeyConverter);
            if (!value) {
              console.warn('Cars filter skipped item with unknown key', key);
              return options;
            }

            options.push({
              count,
              value,
              label: getLabelConverter ? toFilterLabel(key, getLabelConverter) : <span>{toFilterLabel(key)}</span>,
              disabled,
            });
            return options;
          }, [])}
          title={title}
        />

        {!displayAll && !isSessionExpired && counters?.length > maxAmenitiesCount && (
          <div className="result-wrapper__show-link" onClick={() => this.setState({ isFullToShow: !isFullToShow })}>
            {isFullToShow ? (
              <FormattedMessage id="show.less" />) : (
              <FormattedMessage id="show.more" />)}
          </div>)}
      </>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    carsStore: state.carsStore,
    loginStore: state.loginStore,    
  };
};

export const CarsFilterItem = connect(mapStateToProps)(injectIntl(withRouter(CarsFilterItemComponent)));
